import { createContext, useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import SocialNewsInterface from "./components/SocialNews";

export const ThemeContext = createContext(null);

// Route to language code mapping
const routeToLangCode = {
  '/': 'en',
  '/es': 'es',
  '/de': 'de',
  '/fr': 'fr',
  '/pt': 'pt',
  '/hi': 'hi',
  '/indo': 'id',
  '/ru': 'ru',
  '/ch': 'zh',
  '/jp': 'ja',
  '/ar': 'ar',
  '/it': 'it',
  '/tr': 'tr',
  '/nl': 'nl',
  '/gr': 'el'
};

// Component to handle external redirects
const ExternalRedirect = ({ to }) => {
  useEffect(() => {
    window.location.href = to;
  }, [to]);
  return null;
};

// Wrapper component that provides language based on route
const SocialNewsWithLanguage = () => {
  const location = useLocation();
  const langCode = routeToLangCode[location.pathname] || 'en';
  return <SocialNewsInterface initialLanguage={langCode} />;
};

const App = (props) => {
  const t = useSelector(state => state.themeswitch);

  // Initialize theme from localStorage or Redux state
  const getInitialTheme = () => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      return savedTheme;
    }
    return t;
  };

  const [theme, setTheme] = useState(getInitialTheme);

  const { dispatch } = props;

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      <BrowserRouter>
        <Routes>
          {/* Main page - English */}
          <Route path="/" element={<SocialNewsWithLanguage />} />

          {/* External redirect routes */}
          <Route path="/privacy-policy" element={<ExternalRedirect to="https://social.onelike.app/privacy-policy" />} />
          <Route path="/terms-of-use" element={<ExternalRedirect to="https://social.onelike.app/terms-of-use" />} />
          <Route path="/about" element={<ExternalRedirect to="https://social.onelike.app/about" />} />

          {/* Language routes */}
          <Route path="/es" element={<SocialNewsWithLanguage />} />
          <Route path="/de" element={<SocialNewsWithLanguage />} />
          <Route path="/fr" element={<SocialNewsWithLanguage />} />
          <Route path="/pt" element={<SocialNewsWithLanguage />} />
          <Route path="/hi" element={<SocialNewsWithLanguage />} />
          <Route path="/indo" element={<SocialNewsWithLanguage />} />
          <Route path="/ru" element={<SocialNewsWithLanguage />} />
          <Route path="/ch" element={<SocialNewsWithLanguage />} />
          <Route path="/jp" element={<SocialNewsWithLanguage />} />
          <Route path="/ar" element={<SocialNewsWithLanguage />} />
          <Route path="/it" element={<SocialNewsWithLanguage />} />
          <Route path="/tr" element={<SocialNewsWithLanguage />} />
          <Route path="/nl" element={<SocialNewsWithLanguage />} />
          <Route path="/gr" element={<SocialNewsWithLanguage />} />

          {/* Catch-all route - redirect unknown routes to / */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ThemeContext.Provider>
  );
};

const connectedApp = connect(null)(App);
export { connectedApp as App };

